export default "__VITE_ASSET__Cj0ElERi__"